import React from 'react'
import Navbar from './Navbar/Navbar'

export default function PageNotFount() {
  return (
    <>
    <Navbar></Navbar>
    <h1 className='text-danger'>Page Not Fount</h1></>
  )
}
